import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/utils/apiRequest";
import { GET_BASIC_USER_DATA } from "@/constants/Query";
import { IBasicUserData } from "@/types/apiResponse.types";

export const useGetBasicUserDataRequest = () => {
  return useQuery<{
    data: {
      data: IBasicUserData;
    };
  }>({
    queryKey: [GET_BASIC_USER_DATA],
    queryFn: () => apiRequest(GET_BASIC_USER_DATA, "get"),
  });
};
